import { apiClient } from 'v4/core/apiClient';
import { createAvailabilityRequestApi } from './availability-request.api.http';

export const myAvailabilityRequestApi = createAvailabilityRequestApi(apiClient);
